import { IPortfolioItem } from "src/api/client/portfolio/portfolio-table.api.types";

export const getPerfSinceBuy = (item: IPortfolioItem) => (item.bid && item.averagePurchasePrice ? item.bid / item.averagePurchasePrice - 1 : null);

export const getPerfToday = (item: IPortfolioItem) => (item.mid && item.close ? (item.mid - item.close) / item.close : null);
